import PropTypes from 'prop-types';
// material
import { Box } from '@mui/material';
import { grey } from '@mui/material/colors';
import { styled } from '@mui/material/styles';
// components
import PaymentMethodSibsCard from './method/sibs/Card';
import PaymentMethodSibsMBWay from './method/sibs/MBWay';
import PaymentMethodSibsReference from './method/sibs/Reference';
import PaymentMessage from './Message';

const RootStyle = styled('div')(({ theme }) => ({
  marginRight: '16px',
  marginBottom: '16px',
  borderRadius: '16px',
  marginTop: theme.spacing(3),
  padding: theme.spacing(3),
  border: `1px dashed ${grey[300]}`
}));

PaymentStatus.propTypes = {
  transaction: PropTypes.object
};

export default function PaymentStatus({ transaction }) {
  const { payment } = transaction;

  switch (payment.method) {
    case 'CARD':
      return <PaymentMethodSibsCard payment={payment} />;
    case 'MBWAY':
      return <PaymentMethodSibsMBWay payment={payment} />;
    case 'REFERENCE':
      return <PaymentMethodSibsReference transaction={transaction} payment={payment} />;
    default:
      return (
        <RootStyle>
          <Box sx={{ textAlign: 'center' }}>
            <PaymentMessage payment={payment} />
          </Box>
        </RootStyle>
      );
  }
}
